module.exports = __webpack_public_path__ + "static/media/7-en.b2544b6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/7-en.wav
// module id = 7BT+
// module chunks = 1